import { exportResponseHandler } from "../../helpers/downloads";
import { wealthProApi } from "../../redux/api";
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";
import fetchReportCacheSocketHandler from "../clientreports/sockets/fetchReportCacheSocketHandler";

const adviceRegisterEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAdviceRegister: builder.query({
            query: (body) => ({
                url: `api/clientprojectsummary/register/advice`,
                method: 'POST',
                body
            }),
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: useCacheKeyMergeHandler,
            onCacheEntryAdded: fetchReportCacheSocketHandler(false)
        }),
        exportAdviceRegister: builder.query({
            query: (body) => ({
                url: `api/clientprojectsummary/register/advice/export`,
                method: 'POST',
                body,
                responseHandler: exportResponseHandler("Advice Register.csv"),
                cache: 'no-cache'
            })
        })
    })
})

export const {
    useLazyFetchAdviceRegisterQuery,
    useLazyExportAdviceRegisterQuery
} = adviceRegisterEndpoints